export default __webpack_public_path__ + "images/assets/e84b4074bfc4b36391fe6c0a838d0c0c.svg";